var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPurchaseBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11699 21.0006H16.8824C17.2949 21.0006 17.6899 20.8401 17.9857 20.5531L19.6027 18.9837C19.9102 18.685 20.0834 18.2754 20.0834 17.8473V10.1533C20.0834 9.27861 19.3741 8.57031 18.4994 8.57031H5.49996C4.62529 8.57031 3.91602 9.27861 3.91602 10.1533V17.8473C3.91602 18.2754 4.0892 18.685 4.39665 18.9837L6.01368 20.5531C6.30945 20.8401 6.70544 21.0006 7.11699 21.0006Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.5V5.34801C16 5.01957 15.8793 4.70685 15.668 4.48847L14.5166 3.29437C14.3333 3.10482 14.0971 3 13.8512 3H10.1481C9.90286 3 9.66594 3.10482 9.48335 3.29437L8.33198 4.48847C8.12072 4.70685 8 5.01957 8 5.34801V10.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseBag);
export default __webpack_public_path__ + "static/media/purchase_bag.45f23682f55e6e0f47d2d02d067f7263.svg";
export { ForwardRef as ReactComponent };